import { AxiosError, AxiosResponse } from 'axios'
import { REDUX } from 'constants/'
import { ROUTES_NAMES } from 'constants/servicenow.routes'
import { Dispatch } from 'redux'
import { axiosServiceNowApi } from 'services/Api'
import { ResultVariableGetAll, VariableAction } from 'types/variable'
import store from 'store'

const VariableActions = {
    /**
     * Executa dois webservices no serviceNow, ws para lista paginada de setores e ws para contagem de todos os setores
     * @param dispatch dispatch padrão para action setor
     */
    getAllVariables: (dispatch: Dispatch<VariableAction>) => {
        let variablesList = store?.getState()?.variableReducers?.variablesList

        if(variablesList.length === 0){
            const responseSectorList: Promise<AxiosResponse<ResultVariableGetAll>> = axiosServiceNowApi?.get(ROUTES_NAMES.variables.get.all)
            return Promise.all([responseSectorList])
            .then((promisseResponse: [AxiosResponse<ResultVariableGetAll>]) => {
                dispatch({ type: REDUX.reducers.GET_ALL_VARIABLES, payload: promisseResponse[0].data.result } as VariableAction)
            }).catch((error: AxiosError) => {
                dispatch({ type: REDUX.reducers.ERROR_VARIABLES, payload: error.message } as VariableAction)
            }).then(() => ROUTES_NAMES.variables.get.all); 
             
        }

        return ROUTES_NAMES.variables.get.all
    }
}

export default VariableActions